import { gql } from '@apollo/client';
import { CORE_GOAL_FIELDS, ALL_GOAL_FIELDS } from '../fragments/predictiveAudiences';

export const createPredictiveAudienceGoalMutation = gql`
  ${CORE_GOAL_FIELDS}
  mutation createPredictiveAudienceGoal(
    $name: String!
    $userProfileField: String!
    $goal: Json!
    $description: String!
    $listIds: [Long!]!
  ) {
    predictiveAudienceGoalCreate(
      name: $name
      userProfileField: $userProfileField
      goal: $goal
      description: $description
      listIds: $listIds
    ) {
      ...CoreGoalFields
    }
  }
`;

export const updatePredictiveAudienceGoalMutation = gql`
  ${ALL_GOAL_FIELDS}
  mutation updatePredictiveAudienceGoal(
    $id: Long!
    $name: String!
    $userProfileField: String!
    $goal: Json!
    $description: String!
    $listIds: [Long!]!
  ) {
    predictiveAudienceGoalUpdate(
      id: $id
      name: $name
      userProfileField: $userProfileField
      goal: $goal
      description: $description
      listIds: $listIds
    ) {
      ...AllGoalFields
      listIds
    }
  }
`;

export const deletePredictiveAudienceMutation = gql`
  ${ALL_GOAL_FIELDS}
  mutation deletePredictiveAudienceGoal($id: Long!) {
    predictiveAudienceGoalDelete(id: $id) {
      ...AllGoalFields
    }
  }
`;
